import { render, staticRenderFns } from "./HelperButton.vue?vue&type=template&id=54975dd8&scoped=true"
import script from "./HelperButton.vue?vue&type=script&lang=js"
export * from "./HelperButton.vue?vue&type=script&lang=js"
import style0 from "./HelperButton.vue?vue&type=style&index=0&id=54975dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54975dd8",
  null
  
)

export default component.exports